import $ from 'jquery';

const CLASS = {
    IS_OPEN: 'is-open',
    BURGER_CONTENT: '.js-burger-content',
    MENU_BURGER: '.js-header-burger'
};

const key = {
    'ESCAPE': 27
};

export default class BurgerBtn {
    constructor(selectorBurger, selectorBurgerContent, selectorCloseBtn = null) {
        var _self = this;

        // Burger Btn is used to open / close element
        // by himself if no selector to close
        if (!selectorCloseBtn) {
            _self.isToggleBtn = true;
        } else {
            _self.isToggleBtn = false;
            _self.$btnClose = $(selectorCloseBtn);
        }

        // get Btn Element
        _self.$burgerBtn = $(selectorBurger);

        // get related Menu
        _self.$containerBurgerContent = $(selectorBurgerContent);

        // initial state
        _self.isOpen = (_self.$containerBurgerContent.hasClass(CLASS.IS_OPEN)) ? true : false;

        // burger content
        _self.$burgerContent = $(CLASS.BURGER_CONTENT);

        _self.$document = $(document);

        _self.initEventListeners();
    }

    /**
     * Init App
     */
    init() {
        var _self = this;
        _self.bindEvents();
    }

    /**
     * Bind required events
     */
    bindEvents() {
        var _self = this;
        if (_self.isToggleBtn) {
            _self.$burgerBtn.off("click");
            _self.$burgerBtn.on("click", function (e) {
                if(_self.isOpen) {
                    _self.closeMenu();
                } else {
                    _self.openMenu();
                }
                e.stopPropagation();
            });
        }
        else {
            // bind btn burger
            _self.$burgerBtn.off("click");
            _self.$burgerBtn.on("click", function (e) {
                _self.openMenu();
                e.stopPropagation();
            });
            // bind btn close
            _self.$btnClose.off("click");
            _self.$btnClose.on("click", function (e) {
                _self.closeMenu();
                e.stopPropagation();
            });
        }

        _self.$burgerContent.off("click");
        _self.$burgerContent.on("click", function (e) {
            e.stopPropagation();
        });

        // bind close menu clicking everywhere
        _self.$document.on("click", function () {
            if(_self.isOpen) {
                _self.closeMenu();
            }
        });
    }

    /**
     * Gestion de la touche échap
     */
    initEventListeners(){
        document.addEventListener('keyup', (e) => {
            if (e.keyCode === key.ESCAPE){
                const isMenuOpen = $(CLASS.MENU_BURGER).attr('aria-expanded') === 'true';
                if(isMenuOpen) {
                    this.closeMenu();
                    // ▼ afin de remettre le focus sur le bouton
                    setTimeout(() => {
                        $(CLASS.MENU_BURGER).focus();
                    }, 100);
                }
            }
        });
    }

    /**
     * Open Mobile Menu
     */
    openMenu() {
        this.$containerBurgerContent.addClass(CLASS.IS_OPEN);
        this.$burgerBtn.attr("aria-expanded","true");
        this.isOpen = true;
    }

    /**
     * Close Mobile Menu
     */
    closeMenu() {
        this.$containerBurgerContent.removeClass(CLASS.IS_OPEN);
        this.$burgerBtn.attr("aria-expanded","false");
        this.isOpen = false;
    }
}



// WEBPACK FOOTER //
// ./src/components/header/lhs/transverse/burgerBtn.js